<script>
    import { GetMonsterList } from '../../script/_monster'
    import { InputWordCheck, GetContentsList, FilterReset, GetContentsCount } from '../../script/handle/list'

    export let Device, Page, Filter
    let hideFilter = true

    async function searchContents() {
        await GetContentsList(Page)
        await GetContentsCount()
    }

    function OnHideFilter() {
        hideFilter = !hideFilter
    }
</script>

<div class="filters">
    <svg xmlns="http://www.w3.org/2000/svg" class='top left' viewBox="0 0 215 101" fill="none">
        <path d="M0 82.0994L16 101V0H0V82.0994Z" fill="#7A67FF"/>
        <path d="M93.4211 0L117 20L5 20V0L93.4211 0Z" fill="#7A67FF"/>
        <path d="M207.148 13L214.797 20L87.6301 20V13L207.148 13Z" fill="#7A67FF"/>
    </svg>

    <svg xmlns="http://www.w3.org/2000/svg" class='top right' viewBox="0 0 79 16" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M52.0364 0.000488281L35.6844 15.5821H52.0364L68.3883 0.000488281H52.0364Z" fill="#7A67FF"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M25.8192 0.000488281L9.46729 15.5821H25.8192L42.1712 0.000488281H25.8192Z" fill="#7A67FF"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M78.2535 0.000488281L61.9015 15.5821H78.2535V0.000488281Z" fill="#7A67FF"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.76837e-05 15.5815L16.352 -7.34329e-05H4.76837e-05V15.5815Z" fill="#7A67FF"/>
    </svg>

    <svg xmlns="http://www.w3.org/2000/svg" class='bottom' viewBox="0 0 189 124" fill="none">
        <path d="M15.6511 123.979L0 107.979H189V123.979L15.6511 123.979Z" fill="#7A67FF"/>
        <path d="M189 15.6511L173 0V107.978H189V15.6511Z" fill="#7A67FF"/>
    </svg>

    <div class="outline" class:hideFilter={Device == 3 && hideFilter}>
        <div class="inner">
            <div class="subFilter">
                <div class="title">몬스터</div>
                
                <select bind:value={Filter.monster[0]}>
                    <option value={-1}>전체</option>
                    {#each GetMonsterList() as monster}
                        <option
                            value="{monster.num}"
                            disabled={Filter.monster[1] == monster.num}
                        >
                            {monster.name}
                        </option>
                    {/each}
                </select>
    
                <select bind:value={Filter.monster[1]}>
                    <option value={-1}>전체</option>
                    {#each GetMonsterList() as monster}
                        <option
                            value="{monster.num}"
                            disabled={Filter.monster[0] == monster.num}
                        >
                            {monster.name}
                        </option>
                    {/each}
                </select>
                <p>* 사도/동원령 순으로 선택 및 조회됩니다.</p>
            </div>
    
            <div class="subFilter">
                <div class="title">조건 검색</div>
                
                <label><input type="checkbox" bind:checked={Filter.test} /><p>테스트 제외</p></label>
                <label><input type="checkbox" bind:checked={Filter.blank} /><p>공란 제외</p></label>
                <label><input type="checkbox" bind:checked={Filter.neweast} /><p>빌드 최신 버전</p></label>
    
                <select bind:value={Filter.type}>
                    <option value={1}>제목</option>
                    <option value={2}>닉네임</option>
                </select>
                <input
                    type="text"
                    bind:value={Filter.word}
                    placeholder="최대 10글자"
                    on:input={InputWordCheck}
                />
            </div>
        </div>

        <div class="btn">
            {#if Device == 3 }
                {#if hideFilter}
                    <button class='hide' on:click={OnHideFilter}>
                        필터 표시
                    </button>
                {:else}
                    <button class='hide' on:click={OnHideFilter}>
                        숨기기
                    </button>
                {/if}
            {/if}

            {#if Device < 3 || (Device == 3 && !hideFilter)}
                <button class='reset' on:click={() => FilterReset(1)}>
                    초기화
                </button>

                <button class='search' on:click={searchContents}>
                    조회
                </button>
            {/if}
        </div>
    </div>
    
</div>

<style lang="scss">
    .filters {
        width: calc(100% - 31px);
        max-width: 1200px;
        height: fit-content;
        margin: auto;
        margin-bottom: 50px;
        padding: 20px 16px 16px 15px;
        position: relative;

        svg {
            fill: none;
            position: absolute;

            &.top {
                &.left {
                    width: 215px;
                    height: 101px;
                    top: 0px;
                    left: 0px;
                }
                &.right {
                    width: 79px;
                    height: 16px;
                    top: 0px;
                    right: 16px;
                }
            }

            &.bottom {
                width: 189px;
                height: 124px;
                bottom: 0px;
                right: 0px;
            }
        }

        .outline {
            width: calc(100% - 40px - 6px);
            height: calc(100%);
            margin: 0px 0px 0px 0px;
            padding: 20px;
            border: 3px solid $cl3;
            position: relative;

            .inner {
                width: 100%;
                height: 100%;

                .subFilter {
                    background: rgba($color: $cl3, $alpha: 0.3);
                    vertical-align: top;

                    .title {
                        font-family: aggro;
                        font-style: normal;
                        font-weight: 400;
                    }

                    select {
                        cursor: pointer;

                        option {
                            &:checked {
                                background: $cl6;
                                color: $cl2;
                                font-weight: bold;
                            }
                            &:disabled {
                                background: $cl5;
                                color: $cl2;
                                font-weight: bold;
                            }
                        }
                    }
                    
                    p {
                        margin: 0;
                        color: $cl2;
                        font-size: 12px;
                    }
                    
                    label {
                        width: fit-content;
                        font-size: 14px;
                        display: block;
                        cursor: pointer;

                        &:hover {
                            p { color: $cl3; text-decoration: underline; }
                        }

                        input[type=checkbox] {
                            vertical-align: middle;

                            &:checked + p {
                                color: $cl4;
                            }
                        }

                        p {
                            width: fit-content;
                            margin: 0px 5px;
                            display: inline-block;
                            vertical-align: middle;
                        }
                    }
                }

                @include mobile {
                    .subFilter {
                        width: calc(100% - 40px - 3px);
                        padding: 15px 20px;

                        .title { font-size: 14px; }
                    }
                }
                @include tablet {
                    display: flex;
                    justify-content: space-between;
                    
                    .subFilter {
                        width: calc(50% - 80px - 3px);
                        height: calc(182px - 60px);
                        padding: 30px 40px;

                        .title { font-size: 20px; }
                    }
                }
                @include desktop {
                    display: flex;
                    justify-content: space-between;
                    
                    .subFilter {
                        width: calc(50% - 80px - 3px);
                        height: calc(182px - 60px);
                        padding: 30px 40px;

                        .title { font-size: 30px; }
                    }
                }
                @include wide {
                    display: flex;
                    justify-content: space-between;

                    .subFilter {
                        width: calc(50% - 80px - 3px);
                        height: calc(182px - 60px);
                        padding: 30px 40px;

                        .title { font-size: 30px; }
                    }
                }
            }
            
            .btn {
                width: calc(100%);
                margin-top: 20px;
                text-align: right;
        
                button {
                    background: none;
                    margin-left: 10px;
                    color: $cl2;
                    font-family: aggro;

                    &.reset, &.hide {
                        border: 2px solid $cl4;

                        &:hover { background: $cl4; }
                    }
                    &.search {
                        border: 2px solid $cl3;

                        &:hover { background: $cl3; }
                    }
                    
                    @include mobile {
                        padding: 10px 18px 9px 18px;
                        font-size: 10px;
                    }
                    @include tablet {
                        padding: 12px 20px 11px 20px;
                        font-size: 15px;
                    }
                    @include desktop {
                        padding: 12px 20px 11px 20px;
                        font-size: 15px;
                    }
                    @include wide {
                        padding: 12px 20px 11px 20px;
                        font-size: 15px;
                    }
                }
            }

            &.hideFilter {
                .inner { display: none; }
                .btn { margin-top: 0px; }
            }
        }
    }
</style>